import { render, staticRenderFns } from "./stakeholders.vue?vue&type=template&id=22aaabf7&"
import script from "./stakeholders.vue?vue&type=script&lang=js&"
export * from "./stakeholders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports